
import { ajax, getRequestUrl, formatData } from "../request";
export default {
  getTribeList(data,method) {
     return ajax('post', getRequestUrl('/tribe/list'), data, {
      method,
    });
  },
  getTribeDetail(data,method){
    return ajax('post', getRequestUrl('/tribe/detail'), data, {
      method,
    });
  },
  updateTribeInfo(data,method){
    return ajax('post', getRequestUrl('/tribe/updateInfo'), data, {
      method,
    });
  },
  resetTribeInfo(data,method){
    return ajax('post', getRequestUrl('/tribe/resetInfo'), data, {
      method,
    });
  },
  dissolveTribe(data,method){
    return ajax('post', getRequestUrl('/tribe/dissolve'), data, {
      method,
    });
  },
  tickTribe(data,method){
    return ajax('post', getRequestUrl('/tribe/kick'), data, {
      method,
    });
  },
  createTribe(data,method){
    return ajax('post', getRequestUrl('/tribe/create'), data, {
      method,
    });
  },
  getTribeMemberList(data,method){
    return ajax('post', getRequestUrl('/tribe/memberList'), data, {
      method,
    });
  },
  giveFuel(data,method){
    return ajax('post', getRequestUrl('/tribe/giveFuel'), data, {
      method,
    });
  },

  addMember(data,method){
    return ajax('post', getRequestUrl('/tribe/addMember'), data, {
      method,
    });
  },

  setTribeRemark(data,method){
    return ajax('post', getRequestUrl('/tribe/updateRemark'), data, {
      method,
    });
  },
  setAutoSendFuel(data,method){
    return ajax('post', getRequestUrl('/tribe/setAutoSendFuel'), data, {
      method,
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/tribeManagement.js